import { render } from "./Table.vue?vue&type=template&id=0ac1208e&ts=true"
import script from "@/composables/pages/master-setting/partner-agent/TableComposable.ts?vue&type=script&lang=ts"
export * from "@/composables/pages/master-setting/partner-agent/TableComposable.ts?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__